

































import { Vue, Component, Mixins, Prop } from 'vue-property-decorator'
import Modifiable from '@/mixins/Modifiable'

/**
 * Content panel
 */
@Component({ name: 'v-collapse-panel' })
export default class VCollapsePanel extends Mixins(Modifiable) {
    /**
     * Whether the panel header has the entry section
     */
    @Prop({ type: Boolean, default: false })
    hasEntry!: boolean

    /**
     * Style type
     */
    @Prop({ type: String, default: 'primary' })
    type!: 'primary' | 'grey'

    /**
     * Collapse body
     */
    @Prop({ type: Boolean, default: true })
    collapsed!: boolean

    onToggle(): void {
        this.$emit('toggle', !this.collapsed)
    }
}
